export const handleTooltips = (rootElement) => {
    // react-bootstrap is not mature enough at this point to support all the configurations of regular bootstrap tooltips
    window.$('.has-tooltip').each(function() {
        let $el = window.$(this);

        $el.tooltip({
            container: $el.data('container') || rootElement || '.main-body'
        });
    });
};
